<script setup lang="ts">
/**
 * UI-kit component
 * Category: Other
 * Name: DropZoneItemRejected
 */
import type { DropZoneItemRejectedProps } from '../types/interfaces'

import { faFile, faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons'

import { AppText } from '@shared/ui/typography'
import { AppIcon } from '@shared/ui/icons'

import { formatFileSize } from '../utils/format-file-size'

defineOptions({
  name: 'DropZoneItemRejected',
})

defineProps<DropZoneItemRejectedProps>()
</script>

<template>
  <div class="drop-zone-item-rejected">
    <div class="drop-zone-item-rejected__general">
      <AppIcon
        :icon="faFile"
        size="small"
        color="slate-400"
      />
      <div class="drop-zone-item-rejected__info">
        <div class="drop-zone-item-rejected__main">
          <AppText
            name="body2"
            color="slate-900"
            truncate
          >
            {{ name }}
          </AppText>
          <AppText
            name="body2"
            color="slate-400"
          >
            {{ formatFileSize(size) }}
          </AppText>
        </div>
        <AppText
          name="body2"
          class="drop-zone-item-rejected__reason"
        >
          {{ reason }}
        </AppText>
      </div>
    </div>
    <AppIcon
      :icon="faTriangleExclamation"
      size="small"
      color="red-600"
    />
  </div>
</template>

<style lang="scss" scoped src="../styles/_drop-zone-item-rejected.scss" />
